// Func = limiting Scope for this file
document.addEventListener('DOMContentLoaded', DOMReady);
var lastScrollTop = 0;
(function () {
	$(document).ready(function () {
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
		});
	});

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// Dom Ready Funtion
function DOMReady() {
	'use strict';

	// ------- left slider-dots-box ----------
	if (document.querySelectorAll('.slider-block').length > 0) {
		if (document.querySelectorAll('.slider-block_nextpic').length > 0) {
			let positionLeftImage = document.querySelector('.slider-block_nextpic').getBoundingClientRect().left;
			let sliderDots = document.querySelector('.slider-dots-box');
			let leftT = positionLeftImage + 'px';
			sliderDots.style.left = leftT;
		}
	}
	// ------- spaces page -------

	// ------- Hovered Items Navs -------
	if (document.querySelectorAll('.slider-block_nextpic').length > 0) {
		let itemMenu = document.querySelectorAll('.privary-navigation__item a');
		function addClassHovered(arrayItems) {
			arrayItems.forEach(function (i) {
				i.addEventListener(
					'mouseover',
					function (event) {
						i.parentNode.parentElement.classList.add('s-hovered');
					},
					false
				);
				i.addEventListener(
					'mouseout',
					function (event) {
						i.parentNode.parentElement.classList.remove('s-hovered');
					},
					false
				);
			});
		}

		addClassHovered(itemMenu);
	}
	// ------- end spaces page ----------

	// ------- spaces page -------

	let singleQuad = document.querySelectorAll('.single-quad');
	let venuesQuad = document.querySelectorAll('.venues-slider');

	//Eevluate if the page contains single or venues quad
	if (singleQuad.length > 0 || venuesQuad.length > 0) {
		singleQuad.length > 0 ? addClassSeparate(singleQuad) : addClassSeparate(venuesQuad);
	}
	//function  add separate spaces
	function addClassSeparate(arrayItems) {
		arrayItems.forEach((child) => {
			if (child.nextElementSibling.classList.contains('form-module-wrapper')) {
				child.classList.add('js-mb-10');
			}
		});
	}
	// ------- end spaces page ----------

	//email signup animation
	const fieldSelectors = '.form-module__field input, .form-module__field select, .form-module__field textarea';
	document.querySelectorAll('.form-module-wrapper').forEach((form) => {
		document.querySelectorAll(fieldSelectors).forEach((field) => {
			field.addEventListener('focus', () => field.parentElement.classList.add('move'));
			// field.addEventListener('blur', () => field.parentElement.classList.remove('move') );
		});
	});

	const fieldSelect = '.form-module__field select';
	document.querySelectorAll('.form-module').forEach((form) => {
		document.querySelectorAll(fieldSelect).forEach((field) => {
			if (field.firstElementChild.textContent == '---') {
				field.firstElementChild.textContent = '';
			}
		});
	});

	// const filedd =  document.querySelectorAll('.form-module');
	// filedd.forEach((value) => {
	// 	value.classList.add('move')
	// 	document.querySelectorAll(fieldSelect).forEach((field) => {
	// 		console.log('field');
	// 	});
	// });

	//Mobile  menu
	document.getElementById('menu-sm-cta-js').addEventListener('click', function () {
		if (!this.classList.contains('open')) {
			//document.getElementById('menutext-js').innerHTML = "close";
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector('body').classList.add('noScroll');
		}
		if ($('.privary-navigation ul li a').hasClass('.item-open')) {
			$('.item-open').get(0).scrollIntoView(false);
		}
	});
	document.getElementById('menu-cerrar').addEventListener('click', function () {
		document.getElementById('menu-sm-cta-js').classList.remove('open');
		document.getElementById('main-menu').classList.remove('open');
		document.getElementById('header').classList.remove('open-menu');
		document.querySelector('body').classList.remove('noScroll');
	});

	// ------- Add class depending on the number of items-------
	const menuItems = document.querySelector('.privary-navigation__list');
	const countItemsMenu = document.querySelectorAll('.privary-navigation__list > .privary-navigation__item').length;
	if (menuItems.classList.contains('items-' + countItemsMenu)) {
		document.getElementById('header').classList.add('items-' + countItemsMenu);
	}
	// ------- End Add class depending on the number of items -------

	// ------- Toggle open/close on tap. For touch
	if ($(window).width() < 968) {
		$('.secondary-navigation ul.submenu li .active').parents().parents('li').addClass('item-open');

		//Toggle open/close on tap
		$('.secondary-navigation li a')
			.off('click')
			.on('click', function (event) {
				if ($(this).parent().children('.privary-navigation__submenu').length > 0) {
					event.preventDefault();

					if ($(this).next().hasClass('open-menu')) {
						$(this).closest('.inner').removeClass('open');
						$('.secondary-navigation ul li').removeClass('item-open');
						$(this).parent().addClass('item-open');
						$(this)
							.next()
							.slideUp(300, function () {
								if ($('.secondary-navigation ul li a').hasClass('active')) {
									$('.item-open').get(0).scrollIntoView(false);
								}
							})
							.removeClass('open-menu');
					} else {
						$(this).closest('.inner').addClass('open');
						$('.secondary-navigation ul li').removeClass('item-open');
						$(this).parent().addClass('item-open');
						$('.privary-navigation__submenu.open-menu').slideUp(300).removeClass('open-menu');
						$(this)
							.next()
							.addClass('open-menu')
							.slideDown(300, function () {
								if ($('.secondary-navigation ul li a').hasClass('active')) {
									$('.item-open').get(0).scrollIntoView(false);
								}
							});
					}
				}
			});
	} else {
		return;
	}

	const tablesResp = document.querySelectorAll('.mdTable');
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}
	// ------- Toggle open/close on tap. For touch
}
